import { AfterViewInit, ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaginationService } from '../../services';

/**
 * * Componente padrão de paginação do Apolo.
 */
@Component({
  selector: 'ui-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, AfterViewInit {

  /**
   * * Indica se o paginador está dentro do modal.
   */
  @Input() isInsideAModal: 'true' | 'false' = 'false'; // "true" or "false"

  /**
   * * Total de páginas.
   */
  @Input() allPages!: number;
  /**
   * * Página atual.
   */
  @Input() page!: number;

  /*public page;
  public pageSize;
  public collectionSize;
  public allPages;*/
  /**
   * * Configuração para o paginador.
   */
  public config: any = {};

  constructor(public paginationService: PaginationService) { }

  ngOnInit() {
    this.updateVariables();
  }

  ngOnChanges() {
    this.updateVariables();
  }

  @ViewChild('pgDiv', { static: false })
  pgDiv!: ElementRef<HTMLElement>;
  @ViewChild('prev', { static: false })
  prevBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild('next', { static: false })
  nextBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild('pgInput', { static: false })
  pgInput!: ElementRef<HTMLInputElement>;

  /**
   * * Evento emitido ao trocar de página.
   */
  @Output() pgEvent = new EventEmitter<number>();

  ngAfterViewInit() {
    this.prevBtn.nativeElement.disabled = true;
    setTimeout(() => {
      this.updateVariables();
      this.jumpToPg(1);

      if(this.getConfig().allPages > 1) {
        //if(this.allPages <= 1) {
            this.nextBtn.nativeElement.disabled = false;
        }


    }, 500);

    this.updateVariables();
  }

  evtJumpToPg(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.jumpToPg(parseInt(value));
  }

  jumpToPg(value: number) {
    this.updateVariables();
    const page = value;

    if (page > this.getConfig().allPages) {
      this.getConfig().page = this.getConfig().allPages; // muda para a ultima pagina
      this.fireVariableChange();
      this.pgEvent.emit(this.getConfig().allPages);
      this.setPageText(this.getConfig().allPages.toString());
      this.toggleBtns(parseInt(this.getConfig().allPages) +1);
    } else if (page < 1) {
      this.getConfig().page = 1; // muda para a primeira pagina
      this.fireVariableChange();
      this.pgEvent.emit(1);
      this.setPageText('1');
      this.toggleBtns(1);
    } else {
      this.getConfig().page = page; // configura a pagina
      this.fireVariableChange();
      this.setPageText(page.toString());
      this.pgEvent.emit(page); // dispara a mudança de pagina
      this.toggleBtns(page); // Habilita ou desabilita botões
    }

  }

  previousPg() {
    this.jumpToPg(parseInt(this.getConfig().page)-1);
  }

  nextPg() {
    this.jumpToPg(parseInt(this.getConfig().page)+1);
  }

  toggleBtns(page: number) {
    //this.updateVariables();

    const prevBtn = this.prevBtn.nativeElement;
    const nextBtn = this.nextBtn.nativeElement;

    // Toggle Previous Button
    if (page <= 1) {
        prevBtn.disabled = true;
      } else {
       prevBtn.disabled = false;
    }

    //Toggle Next Button
    if ((page <= this.getConfig().allPages) ){
        nextBtn.disabled = false;
     }else{
        nextBtn.disabled = true;
   }

     if((page == this.getConfig().allPages) && (nextBtn.disabled == true)){
      nextBtn.disabled = false;
     }
   }

  setPageText(label:string){
      const pgInput = this.pgInput.nativeElement;
      pgInput.value = label;
  }

  updateVariables(){
    switch (this.isInsideAModal) {
      case "true":
        this.setConfigObj(this.paginationService.modalPage, this.paginationService.modalPageSize, this.paginationService.modalCollectionSize, this.paginationService.modalAllPages);
        break;
      case "false":
        this.setConfigObj(this.paginationService.page, this.paginationService.pageSize, this.paginationService.collectionSize, this.paginationService.allPages);
        break;

      default:
        break;
    }

  }

  setConfigObj(page:number, pageSize:number, collectionSize:number, allPages:number){
    this.config[this.isInsideAModal] = {page:page, pageSize:pageSize, collectionSize:collectionSize, allPages:allPages};
  }

  getConfig(){
    return this.config[this.isInsideAModal];
  }


  fireVariableChange(){
    switch (this.isInsideAModal) {
      case "true":
        this.paginationService.modalPage = this.getConfig().page ;
        this.paginationService.modalPageSize = this.getConfig().pageSize;
        this.paginationService.modalCollectionSize = this.getConfig().collectionSize;
        this.paginationService.modalAllPages = this.getConfig().allPages;

        break;
      case "false":
        this.paginationService.page = this.getConfig().page ;
        this.paginationService.pageSize = this.getConfig().pageSize;
        this.paginationService.collectionSize = this.getConfig().collectionSize;
        this.paginationService.allPages = this.getConfig().allPages;
        break;

      default:
        break;
    }
  }

}
